import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import NavigationItems from '../../NavigationItems/NavigationItems'
import UserMenu from '../../NavigationItems/UserMenu/UserMenu'
import { useHistory } from 'react-router-dom'
import {
    createMuiTheme,
    MuiThemeProvider,
    withStyles
} from "@material-ui/core/styles"
import './SideBar.css'

const drawerWidth = 240;

const defaultTheme = createMuiTheme();
const customTheme = createMuiTheme({
    overrides: {
        MuiPaper: {
            root: {
                backgroundColor: 'transparent !important',
                boxShadow: 'none !important',
                width: '30% !important',
                color: 'gray !important'
            }
        },
        MuiDrawer: {
            paperAnchorLeft: {
                right: '0 !important',
                left: 'auto !important'
            }
        }
    }
});

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth + 'px !important',
        backgroundColor: 'white !important'
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginRight: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: 0,
    },
}));

const PersistentDrawerLeft = (props) => {
    const classes = useStyles();
    const [token, setToken] = useState(window.localStorage.getItem("token"))
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    let history = useHistory();

    const handleDrawerOpen = () => {
        setOpen(true);
        setToken(window.localStorage.getItem("token"))
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const doLogout = (event) => {
        handleDrawerClose()
        window.localStorage.setItem("token", "")
        setToken("")
    }
    const closeSideBar = (event) => {
        setOpen(false)
    }
    const getLogin = (event) => {
        props.getLogin()
        setOpen(false);
    }
    const logOut = token != null && token != '' ? <div>
        <Divider />
        <List>
            <div onClick={doLogout}>
                <div className="SideBarContent">
                    خروج
                </div>
            </div>
        </List>
    </div>
        : ''
    return (
        <div className={classes.root}>
            <MuiThemeProvider theme={defaultTheme}>
                <MuiThemeProvider theme={customTheme}>
                    <CssBaseline />
                    <AppBar
                        position="fixed"
                        className={clsx(classes.appBar, {
                            [classes.appBarShift]: open,
                        })}
                    >
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                className={clsx(classes.menuButton, open && classes.hide)}
                            >
                                <MenuIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="right"
                        open={open}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <div className={classes.drawerHeader}>
                            <IconButton onClick={handleDrawerClose}>
                                {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                            </IconButton>
                        </div>
                        {token != null && token != '' ?
                            <List>
                                <UserMenu closeSideBar={closeSideBar} token={token} />
                            </List>
                            : ''
                        }
                        <Divider />
                        <List>
                            <NavigationItems closeSideBar={closeSideBar} login={getLogin} />
                        </List>
                        {logOut}

                        {/* <List>
                            {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
                                <ListItem button key={text}>
                                    <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                                    <ListItemText primary={text} />
                                </ListItem>
                            ))}
                        </List> */}
                        {/* <List>
                            {['All mail', 'Trash', 'Spam'].map((text, index) => (
                                <ListItem button key={text}>
                                    <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                                    <ListItemText primary={text} />
                                </ListItem>
                            ))}
                        </List> */}

                    </Drawer>
                </MuiThemeProvider>
            </MuiThemeProvider>
        </div>
    );
}
export default PersistentDrawerLeft